import { render, staticRenderFns } from "./outbound-fax-failed-icon.vue?vue&type=template&id=2193ed0c"
import script from "./outbound-fax-failed-icon.vue?vue&type=script&lang=js"
export * from "./outbound-fax-failed-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2193ed0c')) {
      api.createRecord('2193ed0c', component.options)
    } else {
      api.reload('2193ed0c', component.options)
    }
    module.hot.accept("./outbound-fax-failed-icon.vue?vue&type=template&id=2193ed0c", function () {
      api.rerender('2193ed0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/contact-activity/outbound-fax-failed-icon.vue"
export default component.exports